import { NoMoneyModalActionType } from '../../types/noMoneyModalType'

export const closeNoMoneyModal = () => {
    return {type: NoMoneyModalActionType.CLOSE_NO_MONEY_MODAL}
}

export const openNoMoneyModal = () => {
    return {type: NoMoneyModalActionType.OPEN_NO_MONEY_MODAL}
}